





















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'

@Component({
    components: { CopyText },
})
export default class HTTPError extends Vue {
    @Prop() title!: string
    @Prop() status?: number
    @Prop() message?: string
    @Prop() id!: string
    @Prop() supportURL!: string
    @Prop() isMargin?: boolean
}
